import { PropsWithChildren } from 'react';

export const AnchorWrapper = ({
  children,
  className,
  url,
}: PropsWithChildren<{ className: string; url: string }>) => (
  <a className={`${className}__link`} href={url}>
    {children}
  </a>
);
